import React from "react";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { AlertBox } from "../../../../shared/AlertBox/AlertBox";

export function Error() {
  var { tSurvey: t } = useAppTranslation.Survey();

  return <AlertBox variant="error">{t("error.fetch")}</AlertBox>;
}
